import type { MouseEventHandler } from 'react'
import './iconButton.scss'

export interface IconButtonProps {
  src: string
  onClick: MouseEventHandler<HTMLButtonElement>
}

export function IconButton({ src, onClick }: IconButtonProps) {
  return (
    <button className='icon-button' onClick={onClick} type='button'>
      <img src={src} alt='icon-button' className='icon-button__icon' />
    </button>
  )
}
